// config/themes/slots/piratesfortune.theme.ts
import { Theme } from '../../ITheme';
import slotTheme from '../../slot.theme';

const piratesFortuneTheme: Theme = {
  ...slotTheme, // inherit everything from slotTheme

  colors: {
    ...slotTheme.colors,
    background: '#0D1A26', // deep ocean blue
    primary: '#3af3c5ff', // pirate gold
    secondary: '#7063e2ff', // blood red (danger/bonus)
    overlay: 'rgba(13,26,38,0.85)', // semi-transparent sea overlay
    border: '#FFD27F33', // gold translucent borders
  },

  fonts: {
    ...slotTheme.fonts,
    primary: "'Pirata One', cursive", // pirate-style font
    secondary: 'Georgia, serif',
    button: "'Pirata One', cursive",
  },

  uiElements: {
    ...slotTheme.uiElements,
    button: {
      ...slotTheme.uiElements.button,
      padding: '14px 22px',
      fontSize: '18px',
    },
    card: {
      ...slotTheme.uiElements.card,
      borderRadius: '12px',
      shadow: '0 6px 12px rgba(0,0,0,0.3)',
    },
    modal: {
      ...slotTheme.uiElements.modal,
      borderRadius: '16px',
      background: '#1A2B3A',
    },
  },
};

export default piratesFortuneTheme;
